import React from 'react';

function TestimonialSection( {content} ) {

  return (
    <section className='testimonialSection-parent-container'>
      {/* TestimonialCarousel.jsx Component */}
        { content }

    </section>
  )
}

export default TestimonialSection;